import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('growers', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`growers/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('growers', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        loanSave: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('loans', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        imports: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('imports', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`growers/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`growers/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levels: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levels', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        societies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('societies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        sectors: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('sectors', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        clubs: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('clubs', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        contracts: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('contracts', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        seasons: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('seasons', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        loans: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('loans', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        packages: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('packages', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        inputs: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('inputs', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
